/** Query key factory for current-app user (`/api/users/me`). */
export const meKeys = {
  all: ["me"] as const,
  detail: (clerkUserId: string) => [...meKeys.all, clerkUserId] as const,
}
